import { render } from "./SubmissionFail.vue?vue&type=template&id=14840eeb"
import script from "./SubmissionFail.vue?vue&type=script&lang=js"
export * from "./SubmissionFail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__